/*eslint-env browser */
import * as React from 'react'
import { useDispatch } from 'react-redux'
import { signOut } from '@src/redux/actions/auth.actions'
import { Redirect } from 'react-router-dom'
import { Routes } from '@src/constants/routes'
import { useEffect } from 'react'

type Props = {}

const LogoutIDN: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch()
  dispatch(signOut())

  useEffect(() => {}, [])

  return (
    <Redirect
      to={{
        pathname: Routes.loginPage,
        search: window.location.search
      }}
    />
  )
}

export default LogoutIDN
